export interface StateInfo {
  code: string;
  name: string;
}

export const US_STATES: StateInfo[] = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

export const US_CITIES_BY_STATE: Record<string, string[]> = {
  CA: [
    'Los Angeles',
    'San Francisco',
    'San Diego',
    'San Jose',
    'Sacramento',
    'Oakland',
    'Fresno',
    'Long Beach',
    'Bakersfield',
    'Anaheim',
    'Santa Ana',
    'Riverside',
    'Stockton',
    'Irvine',
    'Chula Vista',
    'Fremont',
    'San Bernardino',
    'Modesto',
    'Oxnard',
    'Huntington Beach',
    'Glendale',
    'Santa Clarita',
    'Garden Grove',
    'Santa Rosa',
    'Oceanside',
    'Rancho Cucamonga',
    'Ontario',
    'Elk Grove',
    'Lancaster',
    'Palmdale',
    'Corona',
    'Salinas',
    'Pomona',
    'Torrance',
    'Hayward',
    'Escondido',
    'Sunnyvale',
    'Pasadena',
    'Orange',
    'Fullerton',
    'Thousand Oaks',
    'Visalia',
    'Simi Valley',
    'Concord',
    'Roseville',
    'Santa Clara',
    'Vallejo',
    'Berkeley',
    'El Monte',
    'Downey',
    'Costa Mesa',
    'Carlsbad',
    'Inglewood',
    'Fairfield',
    'Ventura',
    'Richmond',
    'West Covina',
    'Daly City',
    'Burbank',
    'Santa Cruz',
    'Santa Barbara',
    'San Luis Obispo',
    'Palm Springs',
    'Redding',
    'Chico',
    'Monterey',
    'Napa',
    'Laguna Beach',
    'Beverly Hills',
    'Malibu',
    'Newport Beach',
    'Compton',
    'Culver City',
    'Santa Monica',
    'Walnut Creek',
    'San Mateo',
    'Alameda',
    'Manhattan Beach',
    'Hermosa Beach',
    'Redondo Beach',
    'Palo Alto',
    'Mountain View',
    'Cupertino',
    'Orange County',
    'Marin County',
    'Alameda County',
    'Contra Costa County',
    'San Mateo County',
    'Sonoma County',
    'Santa Barbara County',
    'Fresno County',
    'San Bernardino County',
    'Riverside County',
    'San Diego County',
    'Ventura County',
    'Santa Clara County',
  ],
  NY: [
    'New York',
    'Brooklyn',
    'Queens',
    'Manhattan',
    'Bronx',
    'Staten Island',
    'Buffalo',
    'Rochester',
    'Yonkers',
    'Syracuse',
    'Albany',
    'New Rochelle',
    'Mount Vernon',
    'Schenectady',
    'Utica',
    'White Plains',
    'Hempstead',
    'Troy',
    'Niagara Falls',
    'Binghamton',
    'Freeport',
    'Valley Stream',
    'Long Beach',
    'Ithaca',
    'Poughkeepsie',
    'Nanuet',
    'Newburgh',
    'Saratoga Springs',
    'Huntington',
    'Nassau County',
    'Suffolk County',
    'Westchester County',
    'Rockland County',
    'Erie County',
  ],
  TX: [
    'Houston',
    'San Antonio',
    'Dallas',
    'Austin',
    'Fort Worth',
    'El Paso',
    'Arlington',
    'Corpus Christi',
    'Plano',
    'Lubbock',
    'Laredo',
    'Irving',
    'Garland',
    'Frisco',
    'McKinney',
    'Amarillo',
    'Grand Prairie',
    'Brownsville',
    'Killeen',
    'Pasadena',
    'Mesquite',
    'McAllen',
    'Denton',
    'Waco',
    'Carrollton',
    'Midland',
    'Abilene',
    'Beaumont',
    'Round Rock',
    'Odessa',
    'Wichita Falls',
    'Sugar Land',
    'Tyler',
    'College Station',
    'Bryan',
    'Harris County',
    'Dallas County',
    'Tarrant County',
    'Bexar County',
    'Travis County',
  ],
  FL: [
    'Miami',
    'Orlando',
    'Tampa',
    'Jacksonville',
    'St. Petersburg',
    'Hialeah',
    'Port St. Lucie',
    'Cape Coral',
    'Fort Lauderdale',
    'Tallahassee',
    'Pembroke Pines',
    'Hollywood',
    'Gainesville',
    'Miramar',
    'Coral Springs',
    'Clearwater',
    'Palm Bay',
    'Pompano Beach',
    'West Palm Beach',
    'Lakeland',
    'Davie',
    'Miami Gardens',
    'Sunrise',
    'Boca Raton',
    'Deltona',
    'Plantation',
    'Palm Coast',
    'Fort Myers',
    'Sarasota',
    'Bradenton',
    'Pensacola',
    'Kissimmee',
    'Miami-Dade County',
    'Broward County',
    'Palm Beach County',
    'Hillsborough County',
    'Orange County',
  ],
  IL: [
    'Chicago',
    'Aurora',
    'Joliet',
    'Naperville',
    'Rockford',
    'Elgin',
    'Springfield',
    'Peoria',
    'Champaign',
    'Waukegan',
    'Cicero',
    'Bloomington',
    'Arlington Heights',
    'Evanston',
    'Decatur',
    'Schaumburg',
    'Bolingbrook',
    'Palatine',
    'Skokie',
    'Des Plaines',
    'Orland Park',
    'Oak Lawn',
    'Cook County',
    'DuPage County',
    'Lake County',
  ],
  OH: [
    'Columbus',
    'Cleveland',
    'Cincinnati',
    'Toledo',
    'Akron',
    'Dayton',
    'Parma',
    'Canton',
    'Youngstown',
    'Lorain',
    'Hamilton',
    'Springfield',
    'Kettering',
    'Elyria',
    'Cuyahoga County',
    'Franklin County',
    'Hamilton County',
  ],
  GA: [
    'Atlanta',
    'Columbus',
    'Augusta',
    'Macon',
    'Savannah',
    'Athens',
    'Sandy Springs',
    'Roswell',
    'Johns Creek',
    'Warner Robins',
    'Alpharetta',
    'Marietta',
    'Smyrna',
    'Valdosta',
    'Fulton County',
    'DeKalb County',
    'Gwinnett County',
    'Cobb County',
  ],
  NC: [
    'Charlotte',
    'Raleigh',
    'Greensboro',
    'Durham',
    'Winston-Salem',
    'Fayetteville',
    'Cary',
    'Wilmington',
    'High Point',
    'Concord',
    'Asheville',
    'Greenville',
    'Gastonia',
    'Apex',
    'Mecklenburg County',
    'Wake County',
  ],
  WA: [
    'Seattle',
    'Spokane',
    'Tacoma',
    'Vancouver',
    'Bellevue',
    'Kent',
    'Everett',
    'Renton',
    'Spokane Valley',
    'Federal Way',
    'Yakima',
    'Bellingham',
    'Kennewick',
    'Auburn',
    'Pasco',
    'Redmond',
    'Marysville',
    'Kirkland',
    'Richland',
    'Olympia',
    'King County',
    'Pierce County',
    'Snohomish County',
  ],
  AZ: [
    'Phoenix',
    'Tucson',
    'Mesa',
    'Chandler',
    'Scottsdale',
    'Glendale',
    'Gilbert',
    'Tempe',
    'Peoria',
    'Surprise',
    'Yuma',
    'Avondale',
    'Flagstaff',
    'Goodyear',
    'Lake Havasu City',
    'Buckeye',
    'Maricopa County',
    'Pima County',
  ],
  CO: [
    'Denver',
    'Colorado Springs',
    'Aurora',
    'Fort Collins',
    'Lakewood',
    'Thornton',
    'Arvada',
    'Westminster',
    'Pueblo',
    'Greeley',
    'Centennial',
    'Boulder',
    'Highlands Ranch',
    'Longmont',
    'Loveland',
    'Broomfield',
    'Grand Junction',
    'Arapahoe County',
    'Jefferson County',
  ],
  PA: [
    'Philadelphia',
    'Pittsburgh',
    'Allentown',
    'Erie',
    'Reading',
    'Scranton',
    'Bethlehem',
    'Lancaster',
    'Harrisburg',
    'York',
    'Altoona',
    'State College',
    'Wilkes-Barre',
    'Chester',
    'Norristown',
    'Allegheny County',
    'Montgomery County',
    'Bucks County',
  ],
  MI: [
    'Detroit',
    'Grand Rapids',
    'Warren',
    'Sterling Heights',
    'Ann Arbor',
    'Lansing',
    'Dearborn',
    'Livonia',
    'Troy',
    'Westland',
    'Flint',
    'Kalamazoo',
    'Southfield',
    'Rochester Hills',
    'Wyoming',
    'Wayne County',
    'Oakland County',
    'Macomb County',
  ],
  MA: [
    'Boston',
    'Worcester',
    'Springfield',
    'Cambridge',
    'Lowell',
    'Brockton',
    'Quincy',
    'Lynn',
    'New Bedford',
    'Fall River',
    'Lawrence',
    'Newton',
    'Somerville',
    'Framingham',
    'Haverhill',
    'Malden',
    'Waltham',
    'Brookline',
    'Suffolk County',
    'Middlesex County',
    'Essex County',
  ],
  NJ: [
    'Newark',
    'Jersey City',
    'Paterson',
    'Elizabeth',
    'Lakewood',
    'Edison',
    'Woodbridge',
    'Toms River',
    'Hamilton',
    'Trenton',
    'Clifton',
    'Cherry Hill',
    'Brick',
    'Camden',
    'Bayonne',
    'Passaic',
    'East Orange',
    'Union City',
    'Vineland',
    'Hoboken',
    'Bergen County',
    'Essex County',
    'Hudson County',
  ],
  VA: [
    'Virginia Beach',
    'Chesapeake',
    'Norfolk',
    'Richmond',
    'Newport News',
    'Alexandria',
    'Hampton',
    'Roanoke',
    'Portsmouth',
    'Suffolk',
    'Lynchburg',
    'Centreville',
    'Dale City',
    'Reston',
    'Fairfax County',
    'Loudoun County',
    'Prince William County',
  ],
  TN: [
    'Nashville',
    'Memphis',
    'Knoxville',
    'Chattanooga',
    'Clarksville',
    'Murfreesboro',
    'Franklin',
    'Jackson',
    'Johnson City',
    'Bartlett',
    'Hendersonville',
    'Kingsport',
    'Collierville',
    'Cleveland',
    'Davidson County',
    'Shelby County',
  ],
  IN: [
    'Indianapolis',
    'Fort Wayne',
    'Evansville',
    'South Bend',
    'Carmel',
    'Fishers',
    'Bloomington',
    'Hammond',
    'Gary',
    'Lafayette',
    'Muncie',
    'Terre Haute',
    'Kokomo',
    'Noblesville',
    'Marion County',
    'Lake County',
  ],
  MO: [
    'Kansas City',
    'St. Louis',
    'Springfield',
    'Columbia',
    'Independence',
    'Lee\'s Summit',
    'O\'Fallon',
    'St. Joseph',
    'St. Charles',
    'Blue Springs',
    'St. Peters',
    'Florissant',
    'Joplin',
    'Chesterfield',
    'Jackson County',
    'St. Louis County',
  ],
  MD: [
    'Baltimore',
    'Frederick',
    'Rockville',
    'Gaithersburg',
    'Bowie',
    'Hagerstown',
    'Annapolis',
    'College Park',
    'Salisbury',
    'Laurel',
    'Greenbelt',
    'Bethesda',
    'Silver Spring',
    'Towson',
    'Montgomery County',
    'Prince George\'s County',
    'Baltimore County',
  ],
  WI: [
    'Milwaukee',
    'Madison',
    'Green Bay',
    'Kenosha',
    'Racine',
    'Appleton',
    'Waukesha',
    'Oshkosh',
    'Eau Claire',
    'Janesville',
    'West Allis',
    'La Crosse',
    'Sheboygan',
    'Wauwatosa',
    'Milwaukee County',
    'Dane County',
  ],
  MN: [
    'Minneapolis',
    'St. Paul',
    'Rochester',
    'Bloomington',
    'Duluth',
    'Brooklyn Park',
    'Plymouth',
    'Woodbury',
    'Eagan',
    'Maple Grove',
    'St. Cloud',
    'Coon Rapids',
    'Eden Prairie',
    'Burnsville',
    'Hennepin County',
    'Ramsey County',
  ],
  NV: [
    'Las Vegas',
    'Henderson',
    'Reno',
    'North Las Vegas',
    'Sparks',
    'Carson City',
    'Elko',
    'Mesquite',
    'Boulder City',
    'Pahrump',
    'Clark County',
    'Washoe County',
  ],
  UT: [
    'Salt Lake City',
    'West Valley City',
    'Provo',
    'West Jordan',
    'Orem',
    'Sandy',
    'Ogden',
    'St. George',
    'Layton',
    'South Jordan',
    'Lehi',
    'Millcreek',
    'Taylorsville',
    'Logan',
    'Salt Lake County',
    'Utah County',
  ],
  SC: [
    'Charleston',
    'Columbia',
    'North Charleston',
    'Mount Pleasant',
    'Rock Hill',
    'Greenville',
    'Summerville',
    'Sumter',
    'Hilton Head Island',
    'Spartanburg',
    'Florence',
    'Greer',
    'Myrtle Beach',
    'Aiken',
    'Charleston County',
    'Richland County',
  ],
  AL: [
    'Huntsville',
    'Birmingham',
    'Montgomery',
    'Mobile',
    'Tuscaloosa',
    'Hoover',
    'Auburn',
    'Dothan',
    'Decatur',
    'Madison',
    'Florence',
    'Vestavia Hills',
    'Jefferson County',
    'Madison County',
  ],
  KY: [
    'Louisville',
    'Lexington',
    'Bowling Green',
    'Owensboro',
    'Covington',
    'Richmond',
    'Georgetown',
    'Florence',
    'Hopkinsville',
    'Nicholasville',
    'Elizabethtown',
    'Henderson',
    'Jefferson County',
    'Fayette County',
  ],
  LA: [
    'New Orleans',
    'Baton Rouge',
    'Shreveport',
    'Lafayette',
    'Lake Charles',
    'Bossier City',
    'Kenner',
    'Monroe',
    'Alexandria',
    'Houma',
    'Orleans Parish',
    'East Baton Rouge Parish',
  ],
  OR: [
    'Portland',
    'Salem',
    'Eugene',
    'Gresham',
    'Hillsboro',
    'Beaverton',
    'Bend',
    'Medford',
    'Springfield',
    'Corvallis',
    'Albany',
    'Tigard',
    'Lake Oswego',
    'Keizer',
    'Multnomah County',
    'Washington County',
  ],
  OK: [
    'Oklahoma City',
    'Tulsa',
    'Norman',
    'Broken Arrow',
    'Edmond',
    'Lawton',
    'Moore',
    'Midwest City',
    'Enid',
    'Stillwater',
    'Muskogee',
    'Bartlesville',
    'Oklahoma County',
    'Tulsa County',
  ],
  CT: [
    'Bridgeport',
    'Stamford',
    'New Haven',
    'Hartford',
    'Waterbury',
    'Norwalk',
    'Danbury',
    'New Britain',
    'Bristol',
    'Meriden',
    'Milford',
    'West Haven',
    'Fairfield County',
    'Hartford County',
    'New Haven County',
  ],
  IA: [
    'Des Moines',
    'Cedar Rapids',
    'Davenport',
    'Sioux City',
    'Iowa City',
    'Waterloo',
    'Ames',
    'West Des Moines',
    'Council Bluffs',
    'Dubuque',
    'Ankeny',
    'Polk County',
    'Linn County',
  ],
  AR: [
    'Little Rock',
    'Fort Smith',
    'Fayetteville',
    'Springdale',
    'Jonesboro',
    'Rogers',
    'Conway',
    'North Little Rock',
    'Bentonville',
    'Pine Bluff',
    'Hot Springs',
    'Pulaski County',
    'Benton County',
  ],
  MS: [
    'Jackson',
    'Gulfport',
    'Southaven',
    'Biloxi',
    'Hattiesburg',
    'Olive Branch',
    'Tupelo',
    'Meridian',
    'Greenville',
    'Madison',
    'Hinds County',
    'Harrison County',
  ],
  KS: [
    'Wichita',
    'Overland Park',
    'Kansas City',
    'Olathe',
    'Topeka',
    'Lawrence',
    'Shawnee',
    'Manhattan',
    'Lenexa',
    'Salina',
    'Hutchinson',
    'Sedgwick County',
    'Johnson County',
  ],
  NM: [
    'Albuquerque',
    'Las Cruces',
    'Rio Rancho',
    'Santa Fe',
    'Roswell',
    'Farmington',
    'South Valley',
    'Clovis',
    'Hobbs',
    'Alamogordo',
    'Bernalillo County',
    'Doña Ana County',
  ],
  NE: [
    'Omaha',
    'Lincoln',
    'Bellevue',
    'Grand Island',
    'Kearney',
    'Fremont',
    'Hastings',
    'North Platte',
    'Papillion',
    'Columbus',
    'Douglas County',
    'Lancaster County',
  ],
  ID: [
    'Boise',
    'Meridian',
    'Nampa',
    'Idaho Falls',
    'Caldwell',
    'Pocatello',
    'Coeur d\'Alene',
    'Twin Falls',
    'Post Falls',
    'Lewiston',
    'Eagle',
    'Ada County',
    'Canyon County',
  ],
  WV: [
    'Charleston',
    'Huntington',
    'Morgantown',
    'Parkersburg',
    'Wheeling',
    'Weirton',
    'Fairmont',
    'Martinsburg',
    'Beckley',
    'Clarksburg',
    'Kanawha County',
    'Monongalia County',
  ],
  HI: [
    'Honolulu',
    'East Honolulu',
    'Pearl City',
    'Hilo',
    'Kailua',
    'Waipahu',
    'Kaneohe',
    'Mililani Town',
    'Kahului',
    'Ewa Gentry',
    'Honolulu County',
    'Maui County',
    'Hawaii County',
  ],
  NH: [
    'Manchester',
    'Nashua',
    'Concord',
    'Derry',
    'Dover',
    'Rochester',
    'Salem',
    'Merrimack',
    'Hudson',
    'Londonderry',
    'Keene',
    'Hillsborough County',
    'Rockingham County',
  ],
  ME: [
    'Portland',
    'Lewiston',
    'Bangor',
    'South Portland',
    'Auburn',
    'Biddeford',
    'Sanford',
    'Saco',
    'Westbrook',
    'Augusta',
    'Cumberland County',
    'York County',
  ],
  MT: [
    'Billings',
    'Missoula',
    'Great Falls',
    'Bozeman',
    'Butte',
    'Helena',
    'Kalispell',
    'Belgrade',
    'Anaconda',
    'Yellowstone County',
    'Gallatin County',
  ],
  RI: [
    'Providence',
    'Cranston',
    'Warwick',
    'Pawtucket',
    'East Providence',
    'Woonsocket',
    'Cumberland',
    'Coventry',
    'North Providence',
    'South Kingstown',
    'West Warwick',
    'Providence County',
  ],
  DE: [
    'Wilmington',
    'Dover',
    'Newark',
    'Middletown',
    'Smyrna',
    'Milford',
    'Seaford',
    'Georgetown',
    'Elsmere',
    'New Castle County',
    'Kent County',
    'Sussex County',
  ],
  SD: [
    'Sioux Falls',
    'Rapid City',
    'Aberdeen',
    'Brookings',
    'Watertown',
    'Mitchell',
    'Yankton',
    'Pierre',
    'Huron',
    'Spearfish',
    'Minnehaha County',
    'Pennington County',
  ],
  ND: [
    'Fargo',
    'Bismarck',
    'Grand Forks',
    'Minot',
    'West Fargo',
    'Williston',
    'Dickinson',
    'Mandan',
    'Jamestown',
    'Cass County',
    'Burleigh County',
  ],
  AK: [
    'Anchorage',
    'Fairbanks',
    'Juneau',
    'Badger',
    'Knik-Fairview',
    'College',
    'Sitka',
    'Ketchikan',
    'Wasilla',
    'Kenai',
    'Anchorage Borough',
    'Fairbanks North Star Borough',
  ],
  DC: [
    'Washington DC',
    'Georgetown',
    'Capitol Hill',
    'Dupont Circle',
    'Adams Morgan',
    'Anacostia',
    'Columbia Heights',
    'Navy Yard',
  ],
  VT: [
    'Burlington',
    'South Burlington',
    'Rutland',
    'Barre',
    'Montpelier',
    'Winooski',
    'St. Albans',
    'Essex Junction',
    'Chittenden County',
  ],
  WY: [
    'Cheyenne',
    'Casper',
    'Gillette',
    'Laramie',
    'Rock Springs',
    'Sheridan',
    'Green River',
    'Evanston',
    'Jackson',
    'Laramie County',
    'Natrona County',
  ],
  PR: [
    'San Juan',
    'Bayamón',
    'Carolina',
    'Ponce',
    'Caguas',
    'Guaynabo',
    'Mayagüez',
    'Trujillo Alto',
    'Arecibo',
    'Fajardo',
  ],
};

export function getCitiesForState(stateCode: string): string[] {
  if (!stateCode) return US_CITIES_BY_STATE['CA'];
  const codeUpper = stateCode.trim().toUpperCase();
  if (US_CITIES_BY_STATE[codeUpper]) {
    return US_CITIES_BY_STATE[codeUpper];
  }
  return ['Central / Main City', 'Metropolitan Hub', 'County Hub'];
}

export function getStateName(stateCode: string): string {
  if (!stateCode) return 'California';
  const codeUpper = stateCode.trim().toUpperCase();
  const found = US_STATES.find((s) => s.code === codeUpper || s.name.toLowerCase() === stateCode.toLowerCase());
  return found ? found.name : stateCode;
}
